<template>
  <div class="test_all">

    <b-row class="" style="border-bottom: solid 1px black;">
     <b-col style="margin-bottom: 1rem;">
        <b-button size="sm"
          @click="launch_tests()"
          variant="primary"
          :disabled="running"
          >
          Start Tests
        </b-button>
     </b-col>
    </b-row>

    <b-row class="test_row">
     <b-col sm="2">
       <span ref="tst1" class="ntmsg"> Audio Playback </span>
     </b-col>
     <b-col>
      <b-row>
        <b-col>
          {{ msgs[1] }}
        </b-col>
      </b-row>
      <b-row>
       <b-col>
        <b-button size="sm"
          v-if="tst1_show_ques"
          @click="tst1_user_check(true)"
          variant="outline-success"
          >
          Audio Heard
        </b-button>
        <b-button  size="sm"
          v-if="tst1_show_ques"
          @click="tst1_user_check(false)"
          variant="outline-danger"
          >
          Hear Nothing
        </b-button>
       </b-col>
      </b-row>
     </b-col>
    </b-row>

    <b-row class="test_row">
     <b-col sm="2">
       <span ref="tst2" class="ntmsg"> Video Playback </span>
     </b-col>
     <b-col>
      <b-row>
        <b-col>
          {{ msgs[2] }}
        </b-col>
      </b-row>
      <b-row>
       <b-col  style="position:relative;">
          <div id="systest_wall" style="height:2rem;">
          </div>
          <div ref="tst2cnt" style="position:absolute;top:0;left:0;color:blue;">
          </div>
       </b-col>
      </b-row>
     </b-col>
    </b-row>

    <b-row class="test_row">
     <b-col sm="2">
       <span ref="tst3" class="ntmsg"> Microphone </span>
     </b-col>
     <b-col>
      <b-row>
        <b-col>
          {{ msgs[3] }}
        </b-col>
      </b-row>
      <b-row>
       <b-col sm="3"
         style="position:relative;"
         v-if="$parent.audio_sources && tst3_show_rec"
         >
         <b-form-select v-model="$parent.selected_audio_source[$parent.sel_audio_idx]"
            style="padding:0"
            :options="$parent.audio_sources" size="sm"
            @change="$parent.onAudioSourceChange()">
         </b-form-select>
       </b-col>
       <b-col sm="3" style="position:relative;"
         v-if="tst3_show_rec && tst3_percent !== null"
         >
         {{tst3_percent}}%
       </b-col>
       <b-col sm="2" style="position:relative;"
         v-if="tst3_show_rec && tst3_percent !== null"
         >
         <b-button size="sm"
           variant="outline-danger"
           @click="tst3_rec_cancel"
           >
           Cancel
         </b-button>
       </b-col>
       <b-col sm="2">
        <b-button size="sm"
          v-if="tst3_show_play"
          @click="tst3_play"
          variant="primary"
          >
           Play
        </b-button>
       </b-col>
       <b-col>
        <b-button size="sm"
          v-if="tst3_show_ques"
          @click="tst3_user_check(true)"
          variant="outline-success"
          >
          Audio Ok
        </b-button>
        <b-button  size="sm"
          v-if="tst3_show_ques"
          @click="tst3_user_check(false)"
          variant="outline-danger"
          >
          Not Ok
        </b-button>
       </b-col>
      </b-row>
     </b-col>
    </b-row>

  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import MediaDevices from "../mediadevices.js"

export default {
  name: "systest",
  data() {
    return {
      tst1_show_ques: false,
      tst3_show_rec: false,
      tst3_show_play: false,
      tst3_percent: null,
      tst3_show_ques: false,
      running: false,
      msgs: ["","","","",""],
      tests: [],
      report: {},
    }
  },
  components: {
  },
  created() {
  },
  watch: {
   '$parent.selected_audio_source': function(to,from) {
     let vue = this;
     if (vue.tst3_show_rec) {
       vue.tst3_rec_change();       
     }
   },
  },
  mounted() {
    let vue = this;
    $("body").removeClass("setbackground");
    vue.tests.push({
      id: 1,
      ref: vue.$refs.tst1,
      name: "aud-play",
      init: vue.tst1_init,
      start: vue.tst1_load_sound,
      clean: vue.tst1_cleanup,
    });
    vue.tests.push({
      id: 2,
      ref: vue.$refs.tst2,
      name: "vid-play",
      init: vue.tst2_init,
      start: vue.tst2_open,
      clean: vue.tst2_cleanup,
    });
    vue.tests.push({
      id: 3,
      ref: vue.$refs.tst3,
      name: "aud-rec",
      init: vue.tst3_init,
      start: vue.tst3_enumerate,
      clean: vue.tst3_cleanup,
    });

    window.wss_open(vx, {
      acc: vx.acc,
      uid: vx.user.id,
      routes_id: "systest",
      routes: {
      }
    });
  },
  beforeDestroy() {
    let vue = this;
    window.wss_clr_routes(window.vx,"systest");
    vue.tests.forEach(function(t) {
      t.clean(t,t.state || {});
    });
  },
  methods: {
    update_report: function(t,do_create,nr) {
      let vue = this;
      if (do_create) {
        vue.report.r.push({});
      }
      let r = vue.report.r[vue.report.r.length-1];
      r.name = t.name;
      r.tm = Date.now();
      Object.keys(nr).forEach(function(k) {
        r[k] = nr[k];
      });
      if (r.err) {
        vue.report.error = true;
      }
    },
    launch_tests: function() {
      let vue = this;
      vue.report = {r:[]};
      vue.tests.forEach(function(t) {
        t.state = {};
        t.ref.setAttribute("res","");
      });
      vue.report.sys = window.vx.sysinfo || {};
      vue.report.ab = window.vx.about || {};
      vue.report.u = {};
      vue.report.sys.threads = vue.$parent.mydevice.threads;
      vue.report.sys.ua = window.navigator.userAgent;
      vue.report.sys.plat = window.navigator.platform;
      vue.report.sys.ven = window.navigator.vendor;
      vue.report.devid = vue.report.ab.app_uwid;
      if (vx.user) {
        vue.report.u.dname = vx.user.dname;
      }
      vue.running = true;
      vue.tests.forEach(function(t) {
        vue.update_report(t,true,{init:true});
        try {
           t.init(t,t.state);
           vue.update_report(t,false,{done:true});
        } catch(e) {
           let err = e.toString() || "unknown";
           console.error(e,e.toString());
           console.warn(`init failed for ${t.name} ${err}`);
           t.skip = true;
           vue.update_report(t,false,{done:true,err:`failed ${err}`});
           vue.test_result(t);
        }
      });

      vue.current_test = 0;
      vue.test_start();
    },
    test_start: function() {
      let vue = this;
      while (vue.current_test < vue.tests.length &&
             vue.tests[vue.current_test].skip) {
         vue.current_test++;
      }
      if (vue.current_test >= vue.tests.length) {
         vue.running = false;
         console.log("all tests completed");
         console.log(JSON.stringify(vue.report));
         window.wss_send(window.vx, "sys_report", {report: vue.report});
         return;
      }
      let t = vue.tests[vue.current_test];
      console.log(`starting test ${t.name}`);
      t.ref.setAttribute("res","pending");
      vue.run_one(t.start);
    },
    run_one: function(fn) {
      let vue = this;
      let t = vue.tests[vue.current_test];
      vue.update_report(t,true,{});
      try {
        fn(t,t.state);
      } catch(e) {
        let err = "catch:"+(e.toString() || "unknown");
        vue.test_done(err,"An error occurred");
      }
    },
    test_result: function(t) {
      let vue = this;
      // post result
      vue.update_report(t,true,{alldone:true});
      t.clean(t,t.state);
    },
    test_done: function(err,uerr) {
      let vue = this;
      let t = vue.tests[vue.current_test];
      if (err) {
        vue.set_msg(t,uerr || err);
        vue.update_report(t,false,{done:true,err:err});
        console.warn(`error for ${t.name} ${err}`);
        t.ref.setAttribute("res","error");
      } else {
        vue.set_msg(t, "Passed.");
        vue.update_report(t,false,{done:true});
        t.ref.setAttribute("res","ok");
      }
      console.log(`finished test ${t.name}`);
      vue.test_result(t);
      vue.current_test++;
      vue.test_start();
    },
    set_msg: function(t, txt) {
      let vue = this;
      vue.$set(vue.msgs, t.id, txt);
    },

    /************************************************************/

    tst1_init: function(t,s) {
      let vue = this;
      s.ac = window.AudioContext || window.webkitAudioContext;
      s.context = new s.ac();
      /* Must be created in 'trusted', i.e. user gesture, call */
      s.source = s.context.createBufferSource();
      s.source.connect(s.context.destination);
    },
    tst1_load_sound: function(t,s) { console.log("A");
      let vue = this;
      let rq = new XMLHttpRequest();
      let url = "https://s3.amazonaws.com/vuemix-devel/test.aac";
      vue.set_msg(t, "Downloading the test audio file");
      rq.open("GET", url, true);
      rq.responseType = "arraybuffer";
      vue.update_report(t,false,{step:"load sound"});
      rq.onload = function() {
        console.log(rq.status,rq.response.byteLength);
        vue.update_report(t,false,{status:rq.status,
                                   len:rq.response.byteLength});
        if (rq.status < 300) {
          s.aac = rq.response;
          vue.run_one(vue.tst1_decode_sound);
        } else {
          console.log("audio download failed",rq.status);
          vue.test_done("Audio download failed");
        }
      }
      rq.error = function(e) {
        vue.test_done("Audio download failed"+e,"Audio download failed");
      }
      rq.send();
    },
    tst1_decode_sound: function(t,s) { console.log("B",t.id);
      let vue = this;
      vue.set_msg(t, "Decoding the audio file");
      vue.update_report(t,false,{step:"decode sound"});
      s.context.decodeAudioData(s.aac, function(buffer) {
        s.buffer = buffer;
        vue.run_one(vue.tst1_play_sound);
      },function(e) {
        vue.test_done("decode error:"+e,"Audio decode failed");
      });
    },
    tst1_play_sound: function(t,s) { console.log("C");
      let vue = this;
      vue.set_msg(t, "Playing the audio file ...");
      vue.update_report(t,false,{step:"play sound"});
      s.source.buffer = s.buffer;
      s.source.start(0,0,4);
      s.source.onended = function() {
        vue.set_msg(t,"Did you hear the recording?");
        vue.tst1_show_ques = true;
        console.log("tst1 play finished");
      }
    },
    tst1_user_check: function(val) { console.log("D");
      let vue = this;
      vue.tst1_show_ques = false;
      if (!val) {
        vue.test_done("User did not hear audio");
        return;
      }
      vue.test_done();
    },
    tst1_cleanup: function(s) {
      let vue = this;
      if (s.source) {
        s.source.stop();
        s.source.disconnect();
      }
      s.source = null;
      s.context = null;
    },

    /************************************************************/

    tst2_init: function(t,s) {
      let vue = this;

      window.generate_layouts("systest_wall");
      s.video_cnt = 4;
      s.start_sa = 0;

      let opt = {
        sig: "a", /* Tricks it into using external sign-in */
        clientLayout: true,
        noSinglePageSwipe:true,
        preLayoutContents: function(sw, pageTemplates, cs) {
           vue.update_report(t,true,{step:"prelayout"});
           let cells = pageTemplates && pageTemplates[0] &&
                       pageTemplates[0].cells;
           cs.splice(0, cs.length);
           for (let i=0; i < s.video_cnt; ++i) {
              cs.vxAddContent(window.vx.dummy_ct[i]);
           }
           console.log("prelayout done "+cs.length);
        },
        onAPIFail: function(wall, state, error) {
          vue.test_done("api failed:"+error,"Playback failed");
        },
        onPlayerFail: function(x) {
          vue.test_done("player failed:"+x,"Playback failed");
        },
        nextPrevPageButtons:false,
        freezeOnInit:false,
        useVxmsp: 1
      };
      let cfg = {
        serverAddress: vx.subd + ".vuemix.com",
        groupPageSize: 24,
        protocolOverride: "follow",
        loggerSendTo: "",
        overrideVSTemplate: function(vsurl) {
          vsurl = vsurl.replace("sgrp=", "bepi=4000&sub=3&dname=systest&sgrp=");
          return vsurl;
        },
      };
      let rs = {scaleMax: 9.9, scaleMin: 0.02, scaleStep: 0.01,
                xPadding: 0, yPadding: 0,
                xAlignment: "left", yAlignment: "top", ignore: "none" };

      VuemixSDK.useWPlay = true;

      VuemixSDK.config(cfg);
      VuemixSDK.setListener("dash_created", function(player) {
         vue.update_report(t,true,{step:"created"});
      });
      VuemixSDK.setListener("dash_live_timing", function(tm, stm, meta) {
         //console.log("live timing",tm,JSON.stringify(meta));
         if (!meta || !meta.sa) { return; }
         if (!s.start_sa) {
            vue.update_report(t,true,{step:"playing"});
            s.start_sa = meta.sa;
            s.chunk_cnt = 0;
         }
         vue.update_report(t,false,{cnt:s.chunk_cnt});
         vue.$refs.tst2cnt.innerHTML = s.chunk_cnt;
         if (++s.chunk_cnt > 12) {
            vue.$refs.tst2cnt.innerHTML = "";
            setTimeout(vue.test_done, 1);
         }
      });

      s.sw = new VuemixSDK.SimpleWall
        ("systest_wall", 1024, 576, null, rs,
         false, null, null,
         null, // tap
         null, // double-tap
         null, // page-change
         null, null, opt);
   },

    tst2_open: function(t,s) {
      let vue = this;
      vue.set_msg(t,"Testing video playback");
      vue.update_report(t,false,{step:"open wall"});
      vuemix_vs_selected(function() {
        let ly = VuemixLY.base;
        ly.layout = VuemixLY.ly["2x2_256"];
        s.sw.open(function() {
          let x = new VuemixSDK.DataObject.GroupData(ly, "", 0);
          console.log("opened");
          ly.contents = [];
          ly.epoch = 0;
          return x;
        });
      });
    },

    tst2_created: function(t,s) {
      let vue = this;
      vue.update_report(t,false,{step:"player created"});
      vue.test_done();
    },

    tst2_cleanup: function(t,s) {
      let vue = this;
      if (s.sw) {
        s.sw.close();
        s.sw = null;
      }
    },

    /************************************************************/

    tst3_init: function(t,s) {
      let vue = this;
      s.ac = window.AudioContext || window.webkitAudioContext;
      s.context = new s.ac();
      s.thresh = 50;
      s.pcm = new Float32Array(s.thresh*1024);
      s.pcm_at = 0;
      vue.tst3_show_play = false;
      vue.tst3_percent = null;
    },
    tst3_enumerate: function(t, s) {
      let vue = this;
      vue.set_msg(t, "Enumerating");
      vue.tst3_show_rec = true;
      vue.update_report(t,false,{step:"enumerate"});
      vue.$parent.audio_sources = null;
      vue.$parent.refreshAVSources({
        cb: function() {
          // vue.$parent.selected_audio_group[0] == 'Microphones'
          if (!vue.$parent.audio_sources ||
              !vue.$parent.audio_sources.length) {
              vue.test_done("No microphones","No microphones found. Please ensure you have granted access to the device(s).");
              return;
          }
          //console.log(JSON.stringify(vue.$parent.audio_sources));
          //console.log(JSON.stringify(vue.$parent.selected_audio_source));
          vue.update_report(t,false,{
            srcs:JSON.stringify(vue.$parent.audio_sources)
          });
          vue.run_one(vue.tst3_record);
        }
      });      
    },
    tst3_rec_change: function() {
      let vue = this;
      let media = vue.$parent.mydevice.get_media();
      let opt = {};
      opt.gid = vue.$parent.selected_audio_source[0];
      opt.audcap = vue.$parent.mydevice.audcap; /* a hint */
      opt.sel_idx = 0;
      media.streamAudio(opt, function(ctx) {
        console.log("changed");
      });
    },
    tst3_record: function(t,s) {
      let vue = this;
      let media = vue.$parent.mydevice.get_media();
      let opt = {};
      vue.update_report(t,false,{step:"record"});
      vue.set_msg(t,"Select your device; Speak until the recording reaches 100%.");
      s.pcm_at = 0;
      s.sum = 0;
      s.max = 0;
      s.done = false;
      vue.tst3_percent = 0;
      opt.gid = vue.$parent.selected_audio_source[0];
      vue.update_report(t,false,{sel:opt.gid});
      opt.cb_pushraw = function(fct, sr, ch, lbuf, rbuf) {
        if (s.done || !lbuf) { return; }
        let arr32 = new Float32Array(lbuf);
        let sum=0;
        arr32.forEach(function(x) {
          sum += Math.abs(x);
          if (x > s.max) { s.max = x; }
        });
        if (sum < 2) { return; }
        //console.log(Math.trunc(sum), Math.trunc(sum/arr32.length));
        if ((s.pcm_at+arr32.length) <= s.pcm.length) {
          s.sum += sum;
          s.pcm.set(arr32,s.pcm_at);
          s.pcm_at += arr32.length;
          let per = Math.trunc(100*s.pcm_at/s.pcm.length);
          vue.tst3_percent = per;
          vue.update_report(t,false,{percent:per.toFixed(2),
                                     sum:s.sum.toFixed(2),
                                     max:s.max.toFixed(3)});
        } else {
          s.done = true;
          s.avg = Math.trunc(s.sum/s.thresh);
          if (s.max < 0.3 || s.avg < 5) {
            vue.set_msg(t,"Your mic seems quiet. Play to verify.");
          } else {
            vue.set_msg(t,"Everything seems ok. Play to verify.");
          }
          vue.tst3_percent = 100;
          vue.tst3_show_rec = false;
          vue.tst3_show_play = true;
          console.log("done",s.max,s.avg);
          setTimeout(function() {
             media.stopCapture(function() {
             });
          },1);
        }
      };
      media.streamAudio(opt, function(ctx,err) {
        console.log(ctx,err);
        if (!ctx) {
           err = err || "";
           console.warn("audio device error:"+err.error);
           vue.test_done("audio device error:"+err.error,"Device error");
           return;
        }
        media.enableCaptureOutput({start_ep:Date.now()});
      });
    },
    tst3_rec_cancel: function() {
       let vue = this;
       vue.test_done("User cancelled recording");
    },
    tst3_play: function(ev) {
       let vue = this;
       let t = vue.tests[vue.current_test];
       let s = t.state;
       vue.update_report(t,true,{step:"play"});
       let mybuffer = s.context.createBuffer(1, s.pcm.length, 48000);
       let rawbuf = mybuffer.getChannelData(0, 16, 48000);
       for (let i=0; i<s.pcm.length; ++i) {
         let word = s.pcm[i];
         rawbuf[i] = word;//((word + 32768) % 65536 - 32768) / 32768.0;
       }
       /* Must be created in 'trusted', i.e. user gesture, call */
       s.source = s.context.createBufferSource();
       s.source.buffer = mybuffer;
       s.source.onended = function() {
          console.log("playdone");
          vue.tst3_show_ques = true;
       };
       s.source.connect(s.context.destination);
       s.source.start(0);
    },
    tst3_user_check: function(val) {
      let vue = this;
      let t = vue.tests[vue.current_test];
      if (!val) {
        vue.test_done("User did not hear audio");
        return;
      }
      vue.test_done();
    },
    tst3_cleanup: function(t,s) {
      let vue = this;
      vue.tst3_show_ques = false;
      vue.tst3_percent = null;
      vue.tst3_show_play = false;
      vue.tst3_show_rec = false;
    },
    
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>

.test_all {
 margin: 1rem;
 background: white;
}

.test_row {
  min-height: 5rem;
}

.ntmsg {
  width:100%;
  display: inline-block;
  color: black;
  font-size: 0.9rem;
  text-align:center;
  padding: 0.25rem 0.5rem;
  border-radius: 5px;
  border: solid 1px black;
  margin-bottom: 10px;
}
.ntmsg[res="pending"] {
  background-color: #c0c0c0;
}
.ntmsg[res="ok"] {
  color: black;
  background-color: #50b050;
}
.ntmsg[res="error"] {
  color: black;
  background-color: #a03030;
}

</style>
